import { useEffect, useRef } from 'react';
import { tr } from '../lib/i18n.ts';

type Variant = 'close' | 'replace' | 'logout';

/** Asked before the shell discards an app's unsaved work: closing it, opening other content in it, or signing out. */
export function ConfirmDiscard({
  onDiscard,
  onCancel,
  variant = 'close',
}: {
  onDiscard: () => void;
  onCancel: () => void;
  variant?: Variant;
}) {
  const copy = tr.window.discardCopy[variant];
  const ref = useRef<HTMLDialogElement>(null);
  useEffect(() => {
    ref.current?.showModal();
  }, []);
  return (
    <dialog ref={ref} className="confirm" onCancel={onCancel} aria-labelledby="discard-title">
      <h3 id="discard-title">{tr.window.unsavedTitle}</h3>
      <p>{copy.body}</p>
      <div className="confirm-actions">
        <button type="button" className="btn" onClick={onCancel} autoFocus>
          {tr.common.cancel}
        </button>
        <button type="button" className="btn btn-danger" onClick={onDiscard}>
          {copy.action}
        </button>
      </div>
    </dialog>
  );
}
